exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#nav-toggle{cursor:pointer;background:none;border:0;padding:10px 35px 16px 0}#nav-toggle span,#nav-toggle span:after,#nav-toggle span:before{cursor:pointer;border-radius:2px;height:5px;width:35px;position:absolute;display:block;content:\"\"}#nav-toggle.collapsed span:before{top:-10px;transform:rotate(0deg)}#nav-toggle.collapsed span:after{bottom:-10px;transform:rotate(0deg)}#nav-toggle span:after,#nav-toggle span:before{transition:all .5s ease-in-out}#nav-toggle span{background:transparent}#nav-toggle span:before{transform:rotate(45deg)}#nav-toggle span:after{transform:rotate(-45deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/theme-files/assets/snippets/mobile-navigation.css
// module id = 462
// module chunks = 0